import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatNumberWithSpaces } from 'utils/stringUtils';
import { RoiLocationMetric } from '../types';

interface Props {
  locations: RoiLocationMetric[];
}

const LocationUtilisationPanel: React.FC<Props> = ({ locations }) => {
  const { t } = useTranslation('admin');

  return (
    <div className="roi-panel">
      <h3 className="roi-panel-title">{t('roiInsights.panels.locationUtilisation')}</h3>
      {locations.length === 0 ? (
        <div className="roi-panel-empty">{t('roiInsights.noData')}</div>
      ) : (
        <table className="roi-stats-table">
          <thead>
            <tr>
              <th>{t('roiInsights.location.columns.name')}</th>
              <th>{t('roiInsights.location.columns.requests')}</th>
            </tr>
          </thead>
          <tbody>
            {locations.map(loc => (
              <tr key={loc.locationName}>
                <td>{loc.locationName}</td>
                {loc.totalRequests > 0 ? (
                  <td>{t('roiInsights.location.reqs', { value: formatNumberWithSpaces(loc.totalRequests) })}</td>
                ) : (
                  <td className="text-muted">{t('roiInsights.location.noActivity')}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LocationUtilisationPanel;
